import React from 'react';
import jsonData from '../Data.json'; // Import your JSON data

function ResultsPage({ match }) {
 const itemId = parseInt(match.params.id);

 // Find the selected item based on the ID from the route parameter
 const selectedItem = jsonData.find((item) => item.id === itemId);

 return (
  <div>
   <h2>Results</h2>
   {selectedItem ? (
    <div>
     <h3>{selectedItem.title}</h3>
     <p>{selectedItem.paragraph}</p>
    </div>
   ) : (
    <p>Item not found.</p>
   )}
  </div>
 );
}

export default ResultsPage;